import styled from "styled-components";

export const Style = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 32px;

  .loading-ic {
    height: 31.98px;
  }

  .last {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end:
  }

  .w-gap {
    gap: 20px;
  }

  .list-c {
    max-height: 80px;
    overflow: auto;
  }

  .no-wrap {
    flex-wrap: nowrap;
    background: red;
  }

  .flex-wrap {
    gap: 8px;
  }

  .jus-b {
    flex-wrap: wrap;
    justify-content: space-between;
  }

  label {
    color: #101828;
    font-weight: 600;
    font-size: var(--font-size-lg);

    &.muted {
      color: #667085;
    }
  }

  .tag { 
    border: 1px solid #D0D5DD;
    border-radius: 6px;
    padding: 4px 10px;
    color: #000000;
    font-size: 14px;
    font-weight: 500;
  }

  span {
    color: #000000;
    font-size: 14px;
    font-weight: 500;
  }

  .message-box {
    padding: var(--size) 19px;
    border: 1px solid #EAECF0;
    border-radius: 4px;
    display: flex;
    gap: var(--size);

    &.hidden {
      opacity: 0;
    }

    .icon-cont {
      padding: 8px;
      background: #FEF0C7;
      border: 6px solid #FFFAEB;
      border-radius: 28px;

      svg {
        color: #F79009;
        margin-top: -6px;
      }
    }

    p {
      margin-bottom: 0;
      font-size: 14px;
      font-weight: 300;
    }
  }
  
`;
